module.exports = __webpack_public_path__ + "img/50d.29b38bbd.png";